export default __webpack_public_path__ + "static/media/detail_big_13_7.5890ae43.jpg";